"use client";
import React, { ReactNode } from "react";
import EntityModalBase from "../EntityModalBase/EntityModalBase";
import { Collection } from "@/api/collections/types";
import { EndemicImage } from "@/app/(components)/Basic/Image";
import DefaultCollectionImage from "@/assets/graphics/default-collection-image.svg?url";

export interface Props {
  collection: Collection;
  title: string;
  children: ReactNode;
  isOpen: boolean;
  onClose: () => void;
  disableClose?: boolean;
}

function CollectionModalBase({ collection, children, ...props }: Props) {
  return (
    <EntityModalBase {...props} grandChildren={children}>
      <div className="flex flex-col items-center">
        <EndemicImage
          src={collection.imageUrl || DefaultCollectionImage.src}
          placeholder={collection.imagePlaceholder}
          alt={collection.name}
          width={200}
          height={200}
          className="mb-4 w-auto max-h-[110px]"
          aspectRatio
          displayDefaultPlaceholder
        />
        <h2 className="text-body-1 text-primary endemic:text-invert">
          {collection.name}
        </h2>
        <h3 className="text-body-2 text-secondary mb-6  endemic:text-endemicGray-700">
          @{collection.artist?.displayName}
        </h3>
      </div>
    </EntityModalBase>
  );
}

export default CollectionModalBase;
